import styled from '@emotion/styled';
import { space } from '../../constants.js';
import { Box } from '../Box/Box.js';

const Flex = styled(Box)((props)=>({
        display: "flex",
        alignContent: props.alignContent,
        alignItems: props.alignItems,
        alignSelf: props.alignSelf,
        justifyContent: props.justifyContent,
        justifySelf: props.justifySelf,
        flexDirection: props.flexDirection,
        flexWrap: props.flexWrap,
        gap: props.gap ? space[props.gap] : props.flexGap ? space[props.flexGap] : 0,
        order: props.order
    }));

export { Flex };
